import { defineMessage } from 'services/localization';

export const messages = {
    trialActivationTimeoutError: defineMessage('trial_activation_timeout_error_please_try_again'),
    somethingWentWrong: defineMessage('oops_something_went_wrong_2'),
};
